import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
const SvgSortUp = (props, ref) => (_jsx("svg", Object.assign({}, props, { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref }, { children: _jsx("path", { d: "M6 15H17.96c1.33 0 2.003-1.617 1.06-2.56l-5.958-6a1.5 1.5 0 0 0-2.121 0l-5.958 6c-.985.943-.317 2.56 1.019 2.56Zm6-7.5 5.958 6H6.002L12 7.5Z", fillOpacity: 0.87 }, void 0) }), void 0));
const ForwardRef = forwardRef(SvgSortUp);
const Memo = memo(ForwardRef);
export default Memo;
//# sourceMappingURL=SortUp.js.map